import axios, { AxiosInstance } from "axios";
import { conf } from "../../utils/config";

// Tipo para instancias con configuración de fallback
interface AxiosInstanceWithFallback extends AxiosInstance {
  _fallbackBaseURL?: string;
  _skipFallback?: boolean; // Para instancias que no deben usar fallback (ej: reserva)
}

// Headers por defecto en cada instancia para evitar depender de axios.defaults
// y que un fallo en un request (ej. prioridad) no afecte CORS en los siguientes (ej. materias)
const DEFAULT_HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

// Función helper para crear instancias con fallback
const createInstanceWithFallback = (
  baseURL: string,
  fallbackBaseURL?: string,
  skipFallback: boolean = false
): AxiosInstanceWithFallback => {
  const instance = axios.create({
    baseURL,
    headers: DEFAULT_HEADERS,
  }) as AxiosInstanceWithFallback;
  if (fallbackBaseURL) {
    instance._fallbackBaseURL = fallbackBaseURL;
  }
  if (skipFallback) {
    instance._skipFallback = true;
  }
  return instance;
};

const BASE_URL = conf("BASE_URL");

export const axiosInstances = {
  localhost: createInstanceWithFallback(conf("API_URL"), BASE_URL),
  login: createInstanceWithFallback(conf("API_URL_LOGIN"), BASE_URL),
  transacciones0: createInstanceWithFallback(conf("API_URL_TRANSACCIONES0"), BASE_URL),
  transacciones1: createInstanceWithFallback(conf("API_URL_TRANSACCIONES1"), BASE_URL),
  transacciones2: createInstanceWithFallback(conf("API_URL_TRANSACCIONES2"), BASE_URL),
  transacciones3: createInstanceWithFallback(conf("API_URL_TRANSACCIONES3"), BASE_URL),
  transacciones4: createInstanceWithFallback(conf("API_URL_TRANSACCIONES4"), BASE_URL),
  transacciones5: createInstanceWithFallback(conf("API_URL_TRANSACCIONES5"), BASE_URL),
  transacciones6: createInstanceWithFallback(conf("API_URL_TRANSACCIONES6"), BASE_URL),
  transacciones7: createInstanceWithFallback(conf("API_URL_TRANSACCIONES7"), BASE_URL),
  transacciones8: createInstanceWithFallback(conf("API_URL_TRANSACCIONES8"), BASE_URL),
  transacciones9: createInstanceWithFallback(conf("API_URL_TRANSACCIONES9"), BASE_URL),
  validaciones0: createInstanceWithFallback(conf("API_URL_VALIDACIONES0"), BASE_URL),
  validaciones1: createInstanceWithFallback(conf("API_URL_VALIDACIONES1"), BASE_URL),
  validaciones2: createInstanceWithFallback(conf("API_URL_VALIDACIONES2"), BASE_URL),
  validaciones3: createInstanceWithFallback(conf("API_URL_VALIDACIONES3"), BASE_URL),
  validaciones4: createInstanceWithFallback(conf("API_URL_VALIDACIONES4"), BASE_URL),
  validaciones5: createInstanceWithFallback(conf("API_URL_VALIDACIONES5"), BASE_URL),
  validaciones6: createInstanceWithFallback(conf("API_URL_VALIDACIONES6"), BASE_URL),
  validaciones7: createInstanceWithFallback(conf("API_URL_VALIDACIONES7"), BASE_URL),
  validaciones8: createInstanceWithFallback(conf("API_URL_VALIDACIONES8"), BASE_URL),
  validaciones9: createInstanceWithFallback(conf("API_URL_VALIDACIONES9"), BASE_URL),
  oferta0: createInstanceWithFallback(conf("API_URL_OFERTA0"), BASE_URL),
  oferta1: createInstanceWithFallback(conf("API_URL_OFERTA1"), BASE_URL),
  oferta2: createInstanceWithFallback(conf("API_URL_OFERTA2"), BASE_URL),
  oferta3: createInstanceWithFallback(conf("API_URL_OFERTA3"), BASE_URL),
  oferta4: createInstanceWithFallback(conf("API_URL_OFERTA4"), BASE_URL),
  oferta5: createInstanceWithFallback(conf("API_URL_OFERTA5"), BASE_URL),
  oferta6: createInstanceWithFallback(conf("API_URL_OFERTA6"), BASE_URL),
  oferta7: createInstanceWithFallback(conf("API_URL_OFERTA7"), BASE_URL),
  oferta8: createInstanceWithFallback(conf("API_URL_OFERTA8"), BASE_URL),
  oferta9: createInstanceWithFallback(conf("API_URL_OFERTA9"), BASE_URL),
  cupos0: createInstanceWithFallback(conf("API_URL_CUPOS0"), BASE_URL),
  cupos1: createInstanceWithFallback(conf("API_URL_CUPOS1"), BASE_URL),
  cupos2: createInstanceWithFallback(conf("API_URL_CUPOS2"), BASE_URL),
  cupos3: createInstanceWithFallback(conf("API_URL_CUPOS3"), BASE_URL),
  cupos4: createInstanceWithFallback(conf("API_URL_CUPOS4"), BASE_URL),
  cupos5: createInstanceWithFallback(conf("API_URL_CUPOS5"), BASE_URL),
  cupos6: createInstanceWithFallback(conf("API_URL_CUPOS6"), BASE_URL),
  cupos7: createInstanceWithFallback(conf("API_URL_CUPOS7"), BASE_URL),
  cupos8: createInstanceWithFallback(conf("API_URL_CUPOS8"), BASE_URL),
  cupos9: createInstanceWithFallback(conf("API_URL_CUPOS9"), BASE_URL),
  cupos: createInstanceWithFallback(conf("API_URL_CUPOS"), BASE_URL),
  prioridad: createInstanceWithFallback(conf("API_URL_PRIORIDAD"), BASE_URL),
  oferta: createInstanceWithFallback(conf("API_URL_OFERTA"), BASE_URL),
  fijadas: createInstanceWithFallback(conf("API_URL_FIJADAS"), BASE_URL),
  inscritas: createInstanceWithFallback(conf("API_URL_INSCRIPTAS"), BASE_URL),
} as const;